import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import IContact from "@/interfaces/contact.interface";
import contactService from "@/services/contact.service";
import { ByIdRequestProps, RequestsBaseReturn } from "@/types/requests.types";

export type UseGetContactByIdReturn = RequestsBaseReturn<IContact | null>;

export type UseGetContactByIdProps = ByIdRequestProps;

type UseSwrGetContactByIdParams = [string, number];

const useGetContactById = ({ _id }: UseGetContactByIdProps): UseGetContactByIdReturn => {
  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR<IContact, Error, UseSwrGetContactByIdParams | null>(
    _id ? [SWR_KEYS.getContactById, _id] : null,
    ([, contactId]) => contactService.getById(contactId),
    {
      revalidateOnFocus: false,
    }
  );

  return { data, isLoading, error };
};

export default useGetContactById;
